// extracted by mini-css-extract-plugin
module.exports = {"provider":"ProviderLogo_provider__2JLMk","small":"ProviderLogo_small__1r-k0","providersList":"ProviderLogo_providersList__3WyZQ"};